export type PreviewKind = 'markdown' | 'text' | 'image' | 'pdf' | 'unavailable';

const MARKDOWN_EXTENSION = /\.(md|markdown)$/i;
const PDF_EXTENSION = /\.pdf$/i;
const IMAGE_EXTENSION = /\.(png|jpe?g|gif|webp|svg|bmp|ico|avif)$/i;
const TEXT_EXTENSION =
  /\.(txt|text|csv|tsv|json|xml|html?|ya?ml|log|rst|ini|conf|cfg|env|properties|sql|sh|bash|zsh|ts|tsx|js|jsx|css|scss|less|java|kt|go|rs|py|rb|php|c|cpp|h|hpp|cs|swift)$/i;

function isMarkdownMime(mimeType: string | null | undefined): boolean {
  return (
    mimeType === 'text/markdown' ||
    mimeType === 'text/x-markdown' ||
    mimeType === 'application/markdown'
  );
}

function isPdfMime(mimeType: string | null | undefined): boolean {
  return mimeType === 'application/pdf';
}

function isImageMime(mimeType: string | null | undefined): boolean {
  return typeof mimeType === 'string' && mimeType.startsWith('image/');
}

function isPlainTextMime(mimeType: string | null | undefined): boolean {
  if (!mimeType || isMarkdownMime(mimeType)) {
    return false;
  }
  return (
    mimeType.startsWith('text/') ||
    mimeType === 'application/json' ||
    mimeType === 'application/xml' ||
    mimeType === 'application/javascript' ||
    mimeType === 'application/typescript' ||
    mimeType === 'application/xhtml+xml' ||
    mimeType === 'application/csv' ||
    mimeType === 'application/x-csv' ||
    mimeType.endsWith('+json') ||
    mimeType.endsWith('+xml')
  );
}

export function resolvePreviewKind(
  mimeType: string | null | undefined,
  fileName?: string | null,
): PreviewKind {
  const name = typeof fileName === 'string' ? fileName : '';

  if (MARKDOWN_EXTENSION.test(name) || isMarkdownMime(mimeType)) {
    return 'markdown';
  }
  if (PDF_EXTENSION.test(name) || isPdfMime(mimeType)) {
    return 'pdf';
  }
  if (IMAGE_EXTENSION.test(name) || isImageMime(mimeType)) {
    return 'image';
  }
  if (TEXT_EXTENSION.test(name) || isPlainTextMime(mimeType)) {
    return 'text';
  }
  return 'unavailable';
}

export function clampIndex(index: number, length: number): number {
  if (length <= 0) {
    return 0;
  }
  return Math.min(Math.max(0, index), length - 1);
}
